type Props = {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
};

function buildPages(page: number, totalPages: number): (number | string)[] {
  if (totalPages <= 7) return Array.from({ length: totalPages }, (_, index) => index + 1);
  const pages: (number | string)[] = [1];
  const start = Math.max(2, page - 1);
  const end = Math.min(totalPages - 1, page + 1);
  if (start > 2) pages.push("…");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < totalPages - 1) pages.push("…");
  pages.push(totalPages);
  return pages;
}

export default function Pagination({ page, totalPages, onChange }: Props) {
  if (totalPages <= 1) return null;
  const pages = buildPages(page, totalPages);

  return (
    <div className="mt-10 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-300/80 px-3 text-[12px] text-foreground-300 transition-colors hover:border-accent-500/60 hover:text-accent-400 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300/80 disabled:hover:text-foreground-300 font-label"
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {pages.map((item, index) =>
        typeof item === "number" ? (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            className={`h-9 w-9 cursor-pointer rounded-md border text-[12px] transition-colors font-label ${
              item === page
                ? "border-primary-500 bg-primary-500 text-foreground-50"
                : "border-background-300/80 text-foreground-300 hover:border-accent-500/60 hover:text-accent-400"
            }`}
          >
            {item}
          </button>
        ) : (
          <span key={`gap-${index}`} className="px-1 text-foreground-600">
            {item}
          </span>
        ),
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="flex h-9 cursor-pointer items-center gap-1 rounded-md border border-background-300/80 px-3 text-[12px] text-foreground-300 transition-colors hover:border-accent-500/60 hover:text-accent-400 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300/80 disabled:hover:text-foreground-300 font-label"
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </div>
  );
}